import React, { Component } from 'react';
import { connect } from 'redux-zero/react';
import { injectIntl } from 'react-intl';

import { actions } from '../../shared/store.js';
import NotImplemented from '../../components/not-implemented/page-not-implemented.js';
import ScrollToTop from '../../shared/utils.js';
import Seo from '../../infrastructure/seo.js';
import WhoAreWeService from './who-are-we.service.js';

import './who-are-we.scss';

const Section = ({ title, description, illustration }) => (
	<section className="who-are-we-section">
		<div className={`container container-fluid ${illustration}`}>
			<div className=" row ">
				<div
					className="col-xs-12
                col-sm-12
                col-md-12
                col-lg-4
                title"
				>
					<div className="box title">
						<p className="title">{title}</p>
					</div>
				</div>
				<div
					className="col-xs-12
                col-sm-12
                col-md-12
                col-lg-8"
				>
					<div
						className="description"
						dangerouslySetInnerHTML={{ __html: description }}
					/>
				</div>
			</div>
		</div>
	</section>
);

class WhoAreWePage extends Component {
	static prefetchData = async language => WhoAreWeService.getPageData(language);

	state = {
		hasError: false,
	};

	componentDidMount() {
		ScrollToTop();
		if (!this.props.whoAreWePageData) {
			this.fetchData();
		} else {
			this.props.setLoading(false);
		}
	}

	componentDidUpdate(prevProps) {
		ScrollToTop();
		if (this.props.language.value !== prevProps.language.value) {
			this.fetchData();
		}
	}

	fetchData() {
		this.props.setLoading(true);
		WhoAreWePage.prefetchData(this.props.language.value)
			.then((data) => {
				this.props.setWhoAreWePageData(data);
				this.props.setLoading(false);
			})
			.catch((error) => {
				this.props.setLoading(false);
				this.setState({
					hasError: true,
				});
				console.log(error);
			});
	}

	render() {
		const { whoAreWePageData, intl: { formatMessage }, addresses, phones, generalData } = this.props;

		const { hasError } = this.state;

		const regex = /(<([^>]+)>)/ig;

		if (hasError) {
			return <NotImplemented title="Who are we" />;
		}

		return (
			<div className="who-are-we">
				<Seo
					title={formatMessage({ id: 'navigation.about.whoAreWe' })}
					description={(whoAreWePageData && whoAreWePageData.firstDescription) ? whoAreWePageData.firstDescription.replace(regex, '') : formatMessage({ id: 'navigation.about.whoAreWe' })}
					image={whoAreWePageData && `${process.env.REACT_APP_API_ENDPOINT}${whoAreWePageData.image.path}`}
					microdata={`{
									"@context": "https://schema.org",
									"@graph": [
										{
											"@type": "AboutPage",
											"name": "${whoAreWePageData && whoAreWePageData.firstTitle}",
											"description": "${whoAreWePageData && whoAreWePageData.firstDescription.replace(regex, '')}",
											"image": "${whoAreWePageData && `${process.env.REACT_APP_API_ENDPOINT}${whoAreWePageData.image.path}`}"
										},
										{
											"@type": "WebApplication",
											"name": "Inocrowd",
											"url": "${process.env.REACT_APP_WEBSITE_ENDPOINT}",
											"applicationCategory": "BusinessApplication",
											"operatingSystem": "Windows, Linux, OSX, iOS, Android",
											"sameAs": [
												"${process.env.REACT_APP_PLATFORM_ENDPOINT}",
												"https://www.facebook.com/InoCrowd/",
												"https://www.linkedin.com/company/inocrowd",
												"https://twitter.com/InoCrowd",
												"https://www.instagram.com/inocrowd",
												"https://www.youtube.com/channel/UC8JotJA9Txz_6NQXWuEwdvQ"
											],
											"provider": {
												"@type": "Organization",
												"name": "Inocrowd",
												${addresses.length > 0 && `
													"address":  "${addresses[0].description.replace(/\n/g, ' ')}",
												`}
												${phones.length > 0 && `
													"contactPoint": {
														"@type": "ContactPoint",
														"telephone": "${phones[0].phoneNumber}",
														"contactType": "customer service"
													},
													"telephone": "${phones[0].phoneNumber}",
												`}
												${generalData && generalData.logo ? `
													"logo": "${process.env.REACT_APP_API_ENDPOINT}${generalData.logo.path}"
												` : ''}
											}
										},
										{
											"@type": "BreadcrumbList",
											"itemListElement": [
												{
													"@type": "ListItem",
													"name": "Inocrowd",
													"position": 1,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}"
												},
												{
													"@type": "ListItem",
													"name": "${formatMessage({ id: 'navigation.about.whoAreWe' })}",
													"position": 2,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}/about/who-are-we"
												}
											]
										}
									]
								}`}
				/>
				{whoAreWePageData
				&& (
					<Section
						title={whoAreWePageData.firstTitle}
						description={whoAreWePageData.firstDescription}
						illustration="illustration"
					/>
				)
				}
				{whoAreWePageData
				&& (
					<div
						className="full-image"
						style={{
							backgroundImage: `url('${process.env.REACT_APP_API_ENDPOINT}/${whoAreWePageData.image.path}')`,
						}}
					/>
				)
				}
				{whoAreWePageData
				&& (
					<Section
						title={whoAreWePageData.secondTitle}
						description={whoAreWePageData.secondDescription}
					/>
				)
				}
			</div>
		);
	}
}

const mapToProps = ({ language, whoAreWePageData, addresses, phones, generalData }) => ({
	language,
	whoAreWePageData,
	addresses,
	phones,
	generalData,
});
export default connect(
	mapToProps,
	actions,
)(injectIntl(WhoAreWePage));

export { WhoAreWePage };
